import React from "react";

import LegalTerms from '../views/legal/Terms'
import LegalPrivacyPolicy from '../views/legal/PrivacyPolicy'
import LegalCookiePolicy from '../views/legal/CookiePolicy'

import SelectClientOrganization from '../views/auth/SelectClientOrganization'
import AuthLogin from '../views/auth/Login'
import AuthRegistration from '../views/auth/Registration'
import AuthProfile from '../views/auth/Profile'

import AuthDeactivateAccount from '../views/auth/Deactivate'

import {TalentSignup} from '../views/talent/TalentSignup'
import {TalentSignupViaInvite} from '../views/talent/SignupViaInvite'
import AuthTalentSignupWithoutReferral from '../views/talent/SignupWithoutReferral'
import TalentApplication from '../views/talent-application/TalentApplication'
import TalentStatusPage from '../views/talent-application/journey/TalentStatusPage'
import ApplicationSaved from '../views/talent-application/ApplicationSaved'

import TalentProfileApprovalWalkthrough, {
    ProfileApprovalIntro,
    ProfileApprovalNextSteps,
    ProfileApprovalPlatformHighlights,
    ProfileApprovalResumeImport,
    TalentProfileApprovedDetails
} from '../views/talent-dashboard/TalentProfileApprovalWalkthrough'
import {JobBoardList} from '../views/talent-job-board/TalentJobBoard'
import {TalentPortalLayout} from '../views/talent-portal/TalentPortal'
import ProfileEdit from '../views/talent-portal/ProfileEdit'


import ForgotPassword from '../views/passwords/Forgot'
import ResetPassword from '../views/passwords/Reset'
import UpdatePassword from '../views/passwords/Update'

import ClientDashboard from '../views/client-dashboard/ClientDashboard'
import ClientProfile from '../views/clients/Profile'
import MyGroups from '../views/clients/MyGroups'
import ClientRegistration from '../views/clients/Registration'
import ClientConsultantProfile from '../views/clients/ConsultantProfile'

import {ClientMembersList} from '../views/clients/ClientUsersList'
import ProjectGroupsList from '../views/client-project-groups/ProjectGroupsList'
import {EditClientUser} from '../views/users/Edit'
import {InviteClientUser} from '../views/users/Invite'
import CPL from "../views/projects/components/CPL";

import ProjectDetail, {
    ProjectContractHistoryTab,
    ProjectDocumentsTab,
    ProjectOverviewTab,
    ProjectShortlistTab
} from '../views/projects/Detail'
import CreateProject from "../views/create-project/CreateProject";

import CandidateProfile, {ClientViewTalentProfile} from "../views/profiles/TalentProfilePage";
import BrowseTalent from "../views/browse-talent/BrowseTalent";
import TalentPools from "../views/talent-pool/TalentPools";
import TalentPoolManage from "../views/talent-pool/TalentPoolManage";
import {OppRouter} from "../views/talent-opportunities/OpportunityDetails";

import {Navigate, Route} from "react-router-dom";
import LegalLayout from "../views/legal/LegalLayout";
import PageNotFound from "../components/errors/PageNotFound";
import SupplierPortal from "../views/suppliers/SupplierPortal";
import ClientLayout from "../views/clients/ClientLayout";
import BiddingWizard from "../views/project-bidding/BiddingWizard";
import {BriefWizardStep} from "../views/project-bidding/BiddingBriefStep";
import {TalentWizardRedirect, TalentWizardStep} from "../views/project-bidding/BiddingTalentStep";
import {CandidatesWizardStep} from "../views/project-bidding/BiddingCandidatesStep";
import {ContractWizardStep} from "../views/project-bidding/BiddingContractStep";
import ManageProjectGroup from "../views/client-project-groups/ManageProjectGroup";
import ProjectGroupsLayout from "../views/client-project-groups/ProjectGroupsLayout";
import ClientOrgLayout from "../views/client-org/ClientOrgLayout";
import ProjectLayout from "../views/projects/ProjectLayout";
import TalentLayout from "../views/talent/TalentLayout";
import BiddingPositionMatches from "../views/project-bidding/BiddingPositionMatches";
import PositionLayout from "../views/project-position/PositionLayout";
import NewNotificationSettings from "../views/auth/NewNotificationSettings";
import UnsubscribeEmailNotifications from "../views/auth/UnsubscribeEmailNotifications";
import AccountLayout from "../views/auth/AccountLayout";
import TalentSignupLayout from "../views/talent/TalentSignupLayout";
import TalentAdminOppList from "../views/admin/TalentManagerOppList";
import TalentDashboard from "../views/talent-dashboard/TalentDashboard";
import TalentManagerUsersList from "../views/admin/TalentManagerUsersList";
import {TalentContractsList} from "../views/talent-portal/ContractsList";
import {JobDetailPage, JobDetailRedirect} from "../views/talent-job-board/JobDetails";
import {OpportunityList} from "../views/talent-opportunities/OppList";
import WorkPreferences from "../views/talent-preferences/WorkPreferences";
import TalentAdminLayout from "../views/admin/TalentAdminLayout";
import OpportunityProvider from "../providers/OpportunityProvider";
import Dashboard from "../views/Dashboard";
import ClientAdminProjectsList from "../views/admin/ClientAdminProjectsList";
import AdminMessaging from "../views/admin/AdminMessaging";
import AdminMessage from "../views/admin/AdminMessage";
import AdminMessageNew from "../views/admin/AdminMessageNew";
import ClientAdminLayout from "../views/admin/ClientAdminLayout";
import ProjectSetupLayout from "../views/projects/ProjectSetupLayout";
import TalentTeamsList from "../views/talent-teams/TalentTeamsList";
import TalentTeamLayout from "../views/talent-teams/TalentTeamLayout";
import TalentTeamSetup from '../views/talent-teams/TalentTeamSetup';
import Validate2FA from "../views/auth/Validate2FA";
import SupplierDashboard from "../views/suppliers/SupplierDashboard";
import SupplierLayout from "../views/suppliers/SupplierLayout";
import SupplierPlans from "../views/suppliers/SupplierPlans";
import SupplierTalentProfileEdit from "../views/suppliers/SupplierTalentProfileEdit";
import SupplierManageProfile from "../views/suppliers/SupplieManageProfile";
import SupplierImportProfileWizard from "../views/suppliers/SupplierImportProfileWizard";
import SupplierJobBoard from "../views/suppliers/SupplierJobBoard";
import SupplierJobBoardDetails from "../views/suppliers/SupplierJobBoardDetails";
import {AgencyOpportunityList} from "../views/suppliers/SupplierOppList";
import {AgencyOppRouter} from "../views/suppliers/SupplierOppDetails";
import ClientViewTeamProfile, {ClientViewTeamCandidateProfile} from "../views/profiles/TeamProfilePage";
import ClientViewAgencyProfile from "../views/profiles/AgencyProfilePage";
import ActiveOppDetails from "../views/talent-opportunities/ActiveOppDetails";
import OppSurvey from "../views/talent-opportunities/OppSurvey";
import OpportunityLayout from "../views/talent-opportunities/OpportunityLayout";
import {OppDashboardTab} from "../views/talent-opportunities/OppDashboard";
import {OppBriefTab} from "../views/talent-opportunities/OppBriefStep";
import {OppTeamStatusTab} from "../views/talent-opportunities/OppTeamStatusStep";
import {OppContractTab} from "../views/talent-opportunities/OppContractStep";
import BiddingTeamMatches from "../views/project-bidding/components/BiddingTeamMatches";
import {ManageScopeStep} from "../views/project-bidding/BiddingManageScopeStep";
import TalentManagerTeamsList from "../views/admin/TalentManagerTeamsList";
import TalentTeamNew from "../views/talent-teams/TalentTeamNew";
import TalentPoolAdd from "../views/talent-pool/TalentPoolAdd";
import TalentPoolProvider from "../providers/TalentPoolProvider";
import TalentPoolProfile from "../views/talent-pool/TalentPoolProfile";
import TalentMessages from "../views/talent-messages/TalentMessages";
import BrowseTalentLayout, {BrowseTalentProfile} from "../views/browse-talent/BrowseTalentLayout";
import BrowseTeamsLayout, {BrowseTeamsProfile} from "../views/browse-talent/BrowseTeamsLayout";
import BrowseTeams from "../views/browse-talent/BrowseTeams";
import TalentPoolWelcome from "../views/talent-pool/TalentPoolWelcome";
import TalentPoolLayout from "../views/talent-pool/TalentPoolLayout";
import BrowseAgenciesLayout, {BrowseAgencyProfile} from "../views/browse-talent/BrowseAgenciesLayout";
import BrowseAgencies from "../views/browse-talent/BrowseAgencies";
import FinancialsLayout from '../views/financials/FinancialsLayout'
import TalentTimePayments from '../views/financials/TalentTimePayments'
import ContractProgression from '../views/financials/ContractProgression'
import ProjectBurnSpend from '../views/financials/ProjectBurnSpend'

const ErrorHandler = (error, info) => {
    // Do something with the error
    // E.g. log to an error logging client here
    console.warn("ErrorHandler", error, info)

    try {
        TB.BugsnagClient.notify(error, {metaData: info})
    } catch (e) {
    }
}

class Navigation {

    static getRouteList() {
        let routes = [];
        let childs = this.appRoutes().props.children.props.children;

        const mapRoutes = (path, element) => {
            let childpath = TB.replace(path, '*', '');
            if (!element.props.index && !childpath.endsWith(TB.replace((element.props.path || ''), '*', ''))) {
                childpath = childpath + TB.replace((element.props.path || ''), '*', '')
            }
            let childroutes = []
            if (childpath.length > 1) {
                childroutes.push(childpath);
            }
            if (TB.isArray(element.props.children)) {

                TB.map(element.props.children, subchild => {

                    let subpath = childpath;
                    if (!subchild.props.index && !subpath.endsWith(TB.replace((subchild.props.path || ''), '*', ''))) {
                        subpath = TB.replace((subchild.props.path || ''), '*', '')

                        if (subpath.length > 0) {
                            subpath = childpath + subpath
                        }
                    }
                    childroutes = [
                        ...childroutes,
                        ...mapRoutes(subpath, subchild)
                    ]
                })
            }else if(element.props.children) {
                childroutes = [
                    ...childroutes,
                    ...mapRoutes(childpath, element.props.children)
                ]
            }
            return childroutes;
        }


        TB.map(childs, child => {
            routes = [...routes,...mapRoutes('', child)]
        })

        let group = TB.groupBy(routes, route => {
            return TB.capitalize(route.substring(0, route.indexOf("/")));
        })
        console.log('getRouteList', group)
    }
    static appRoutes() {

        return (
            <>
                <Route index element={<Navigate to="dashboard" replace={true}/>}/>
                <Route path="dashboard/*" element={<Dashboard/>}/>
                <Route path="system/*" element={<Dashboard/>}/>
                <Route path="legal/*" element={<LegalLayout/>}>
                    <Route path="privacy-policy" element={<LegalPrivacyPolicy/>}/>
                    <Route path="terms" element={<LegalTerms/>}/>
                    <Route path="cookie-policy" element={<LegalCookiePolicy/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Route>
                <Route path="password/forgot" element={<ForgotPassword/>}/>
                <Route path="password/reset/:token" element={<ResetPassword/>}/>

                <Route path="settings/notifications/manage" element={<NewNotificationSettings/>}/>
                <Route path="settings/notifications/all/opt-out" element={<UnsubscribeEmailNotifications/>}/>
                <Route path="settings/notifications/email/:template_id/opt-out" element={<UnsubscribeEmailNotifications/>}/>

                <Route path="login" element={<AuthLogin/>}/>
                <Route path="authorize" element={<Validate2FA/>}/>
                <Route path="register/:token" element={<AuthRegistration/>}/>


                <Route path="signup/*" element={<TalentSignupLayout/>}>
                    <Route path="talent" element={<AuthTalentSignupWithoutReferral/>}/>
                    <Route path="talent/:token" element={<TalentSignup/>}/>
                    <Route path="invite/talent/:token" element={<TalentSignupViaInvite/>}/>
                    <Route path="*" element={<Navigate to="talent" replace={true}/>}/>
                </Route>
                <Route path="account/*" element={<AccountLayout/>}>
                    <Route path="password/update" element={<UpdatePassword/>}/>
                    <Route path="my-profile" element={<AuthProfile/>}/>
                    <Route path="deactivate" element={<AuthDeactivateAccount/>}/>
                    <Route path="settings" element={<NewNotificationSettings/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Route>


                <Route path="supplier/*" element={<SupplierLayout/>}>

                    <Route index element={<Navigate to="dashboard" replace={true}/>}/>
                    <Route path="talent-resources/:talentUserId/*" element={<SupplierTalentProfileEdit/>}/>
                    <Route path="plans" element={<SupplierPlans/>}/>

                    <Route path="manage-profile/*" element={<SupplierManageProfile/>}/>
                    <Route path="import-profile/*" element={<SupplierImportProfileWizard/>}/>

                    <Route path="team/manage/*" element={<TalentTeamLayout/>}>
                        <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                    </Route>

                    <Route path="team/setup/*" element={<TalentTeamLayout/>}>
                        <Route index element={<Navigate to="new" replace={true}/>}/>
                        <Route path="new" element={<TalentTeamNew/>}/>
                        <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                    </Route>

                    <Route element={<SupplierPortal/>}>

                        <Route path="dashboard" element={<SupplierDashboard/>}/>

                        <Route path={'contracts'} element={<TalentContractsList/>}/>

                        <Route path={'projects/:status'} element={<AgencyOpportunityList/>}/>

                        <Route path="job-board">
                            <Route index element={<SupplierJobBoard/>}/>
                            <Route path="job-details/:jobId" element={<SupplierJobBoardDetails/>}/>
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>

                        <Route path="teams/*" element={<TalentTeamLayout/>}>
                            <Route index element={<Navigate to="all" replace={true}/>}/>
                            <Route path={":status"} element={<TalentTeamsList/>}/>
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>

                        <Route path="members/invite" element={<InviteClientUser/>}/>

                    </Route>

                    <Route path={'project/:oppId/*'}
                           element={<OpportunityProvider><AgencyOppRouter/></OpportunityProvider>}/>

                </Route>


                <Route path="client/*" element={<ClientLayout/>}>
                    <Route path="talent-pool/*" element={<TalentPools/>}>
                        <Route index element={<TalentPoolWelcome/>}/>
                        <Route path={":talentPoolId/*"} element={<TalentPoolProvider><TalentPoolLayout/></TalentPoolProvider>}>
                            <Route index element={<TalentPoolManage/>}/>
                            <Route path={"add-talent/*"} element={<TalentPoolAdd/>}/>
                            <Route path="*" element={<TalentPoolProfile/>}/>

                        </Route>

                    </Route>
                    <Route path="manager/*" element={<ClientAdminLayout/>}>
                        <Route path="projects" element={<ClientAdminProjectsList/>}/>
                        <Route path="messaging" element={<AdminMessaging/>}/>
                        <Route path="messaging/new" element={<AdminMessageNew/>}/>
                        <Route path="messaging/:messageId" element={<AdminMessage/>}/>
                        <Route path="*" element={<PageNotFound/>}/>
                    </Route>

                    <Route path="dashboard" element={<ClientDashboard/>}/>
                    <Route path="browse/*">
                        <Route index element={<Navigate to={'talent'} replace={true}/>}/>
                        <Route path="talent/*" element={<BrowseTalentLayout/>}>
                            <Route index element={<BrowseTalent/>}/>
                            <Route path={'talent-profiles/:profileId/*'} element={<BrowseTalentProfile/>}/>
                            <Route path={'agency-profiles/:agencyId/*'} element={<ClientViewAgencyProfile/>}/>
                        </Route>
                        <Route path="teams/*" element={<BrowseTeamsLayout/>}>
                            <Route index element={<BrowseTeams/>}/>
                            <Route path={"team-profiles/:teamId/*"} element={<BrowseTeamsProfile/>}/>
                            <Route path={'agency-profiles/:agencyId/*'} element={<ClientViewAgencyProfile/>}/>
                        </Route>
                        <Route path="agencies/*" element={<BrowseAgenciesLayout/>}>
                            <Route index element={<BrowseAgencies/>}/>
                            <Route path={'agency-profiles/:agencyId/*'} element={<BrowseAgencyProfile/>}/>
                        </Route>
                        <Route path="*" element={<PageNotFound/>}/>

                    </Route>
                    <Route path="projects/*">
                        <Route index element={<Navigate to="all" replace={true}/>}/>
                        <Route path={":status"} element={<CPL/>}/>
                    </Route>
                    {/*<Route path="projects2/*" element={<CPL/>}>*/}
                    {/*    <Route index element={<Navigate to="all" replace={true}/>}/>*/}
                    {/*    <Route path={":status"} element={<CPL/>}/>*/}
                    {/*</Route>*/}
                    <Route path="project/*">
                        <Route path="setup/*" element={<ProjectSetupLayout/>}>
                            <Route index element={<Navigate to="new" replace={true}/>}/>
                            <Route path=":projectId/*" element={<CreateProject/>}/>
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>

                        <Route path="bidding/*" element={<ProjectLayout/>}>
                            <Route path=":projectId/*" element={<BiddingWizard/>}>
                                <Route path="brief/*">
                                    <Route index element={<BriefWizardStep/>}/>
                                    <Route path=":section/*" element={<BriefWizardStep/>}/>
                                </Route>

                                <Route path="manage-scope/*" element={<ManageScopeStep/>}/>
                                <Route path="talent-pool/*" element={<TalentWizardStep/>}>
                                    <Route path="teams/*">
                                        <Route index element={<BiddingTeamMatches/>}/>
                                        <Route path="team-profiles/*" element={<TalentTeamLayout/>}>
                                            <Route path=":teamId/*" element={<ClientViewTeamCandidateProfile/>}/>
                                        </Route>
                                    </Route>
                                    <Route path="role/:positionId/*">
                                        <Route index element={<BiddingPositionMatches/>}/>
                                        <Route path="talent-profiles/:profileId/*" element={<CandidateProfile/>}/>
                                    </Route>
                                    <Route path="*" element={<TalentWizardRedirect/>}/>
                                </Route>
                                <Route path="shortlist/*" element={<PositionLayout/>}>
                                    <Route index element={<CandidatesWizardStep/>}/>
                                    <Route path="talent-profiles/:profileId/*" element={<CandidateProfile/>}/>
                                    <Route path="team-profiles/*" element={<TalentTeamLayout/>}>
                                        <Route path=":teamId/*" element={<ClientViewTeamCandidateProfile/>}/>
                                    </Route>
                                </Route>

                                <Route path="contract/*" element={<ContractWizardStep/>}/>
                                <Route path="*" element={<PageNotFound/>}/>
                            </Route>
                        </Route>

                        <Route path="active/*" element={<ProjectLayout/>}>
                            <Route path=":projectId/*" element={<ProjectDetail/>}>
                                <Route index element={<Navigate to="overview" replace={true}/>}/>
                                <Route path="brief/:section?/*" element={<BriefWizardStep toggleDisabled={()=> true}/>}/>
                                <Route path="overview" element={<ProjectOverviewTab/>}/>
                                <Route path="contract-history" element={<ProjectContractHistoryTab/>}/>
                                <Route path="documents" element={<ProjectDocumentsTab/>}/>
                                <Route path="short-list" element={<ProjectShortlistTab/>}>
                                    <Route element={<PositionLayout/>}>
                                        <Route index element={<CandidatesWizardStep toggleDisabled={()=> true}/>}/>
                                        <Route path="talent-profiles/:profileId/*" element={<CandidateProfile/>}/>
                                        <Route path="team-profiles/*" element={<TalentTeamLayout/>}>
                                            <Route path=":teamId/*" element={<ClientViewTeamCandidateProfile/>}/>
                                        </Route>
                                    </Route>
                                </Route>
                                <Route path="*" element={<PageNotFound/>}/>
                            </Route>
                        </Route>

                        <Route path="*" element={<PageNotFound/>}/>

                    </Route>

                    <Route path="my-groups" element={<MyGroups/>}/>
                    <Route path="client-success-rep" element={<ClientConsultantProfile/>}/>

                    <Route path="org/*" element={<ClientOrgLayout/>}>
                        <Route path="profile" element={<ClientProfile/>}/>
                        <Route path="groups/*" element={<ProjectGroupsLayout/>}>
                            <Route index element={<ProjectGroupsList/>}/>
                            <Route path=":groupId" element={<ManageProjectGroup/>}/>
                        </Route>
                        <Route path="registration" element={<ClientRegistration/>}/>
                        <Route path="select-organization" element={<SelectClientOrganization/>}/>
                        <Route path="users/*">
                            <Route index element={<ClientMembersList/>}/>
                            <Route path=":status" element={<ClientMembersList/>}/>
                        </Route>
                        <Route path="members/invite" element={<InviteClientUser/>}/>
                        <Route path="members/:userId/edit" element={<EditClientUser/>}/>
                        {/* <Route path="*" element={<PageNotFound/>}/> */}
                    </Route>

                    {TB.isLocalOrStagingEnv() && (
                        <Route path="financials/*" element={<FinancialsLayout/>}>
                            <Route index element={<Navigate to="talent-payments" replace={true}/>}/>
                            <Route path="talent-payments" element={<TalentTimePayments/>}/>
                            <Route path="contract-progression" element={<ContractProgression/>}/>
                            {/* Hidden for now - see the matching entry in FinancialsLayout navItems */}
                            {/* <Route path="project-burn-spend" element={<ProjectBurnSpend/>}/> */}
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>
                    )}

                    <Route path="*" element={<PageNotFound/>}/>
                </Route>

                <Route path="talent-profiles/:profileId/*" element={<ClientViewTalentProfile/>}/>
                <Route path="team-profiles/*" >
                    <Route path=":teamId/*" element={<ClientViewTeamProfile/>}/>
                </Route>
                <Route path="agency-profiles/:agencyId/*" element={<ClientViewAgencyProfile/>}/>

                <Route path="talent/*" element={<TalentLayout/>}>

                    <Route path="application/*" element={<TalentApplication/>}/>
                    {/* Save & Exit now lands on the "Welcome back" view of the application start step */}
                    <Route path="application-saved" element={<Navigate to="/talent/application/get-started" state={{saved: true}} replace/>}/>

                    {/* Login status screens: where the talent is in the application/profile journey */}
                    <Route path="welcome-back" element={<TalentStatusPage/>}/>
                    <Route path="under-review" element={<TalentStatusPage/>}/>
                    <Route path="review-completed" element={<TalentStatusPage/>}/>
                    <Route path="welcome/*" element={<TalentProfileApprovalWalkthrough/>}>
                        <Route index element={<ProfileApprovalIntro/>}/>
                        <Route path="platform-highlights" element={<ProfileApprovalPlatformHighlights/>}/>
                        <Route path='import-resume' element={<ProfileApprovalResumeImport/>}/>
                        <Route path="next-steps" element={<ProfileApprovalNextSteps/>}/>
                        <Route path="profile-approved" element={<TalentProfileApprovedDetails/>}/>
                        <Route path={'*'} element={<PageNotFound/>}/>
                    </Route>
                    {/*<Route path="welcome-update" element={<TalentVersionUpdate/>}/>*/}
                    <Route path="project/:oppId/*" element={<OpportunityLayout/>}>
                        <Route path="survey" element={<OppSurvey/>}/>
                        <Route path="review-contract" element={<ActiveOppDetails/>}/>
                        <Route path="*" element={<OppRouter/>}>
                            <Route index element={<Navigate to={'proposal'} replace/>}/>
                            <Route path={'proposal/*'} element={<OppDashboardTab/>}/>
                            <Route path={'review-project-brief/*'} element={<OppBriefTab/>}/>
                            <Route path={'pursuit-status/*'} element={<OppTeamStatusTab/>}/>
                            <Route path={'sign-contract/*'} element={<OppContractTab/>}/>
                            <Route path={'*'} element={<PageNotFound/>}/>
                        </Route>
                    </Route>

                    <Route path="team/manage/*" element={<TalentTeamLayout/>}>
                        <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                    </Route>

                    <Route path="team/setup/*" element={<TalentTeamLayout/>}>
                        <Route index element={<Navigate to="new" replace={true}/>}/>
                        <Route path="new" element={<TalentTeamNew/>}/>
                        <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                    </Route>
                    {/*<Route path="team/manage/:teamId/*" element={<TalentTeamLayout/>}>*/}
                    {/*    <Route index element={<TalentTeamManage/>}/>*/}
                    {/*    <Route path="edit/*" element={<TalentTeamSetup/>}/>*/}
                    {/*</Route>*/}
                    <Route path="manager/*" element={<TalentAdminLayout/>}>
                        <Route element={<TalentPortalLayout/>}>
                            <Route path="opportunities" element={<TalentAdminOppList/>}/>
                            <Route path="talent-vetting" element={<TalentManagerUsersList/>}/>
                            <Route path="teams/*" element={<TalentManagerTeamsList/>}/>
                        </Route>
                        <Route path="team/manage/*" element={<TalentTeamLayout/>}>
                            <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                        </Route>

                        <Route path="team/setup/*" element={<TalentTeamLayout/>}>
                            <Route index element={<Navigate to="new" replace={true}/>}/>
                            <Route path="new" element={<TalentTeamNew/>}/>
                            <Route path=":teamId/*" element={<TalentTeamSetup/>}/>
                        </Route>
                    </Route>


                    <Route element={<TalentPortalLayout/>}>
                        <Route path="teams/*">
                            <Route index element={<Navigate to="all" replace={true}/>}/>
                            <Route path={":status"} element={<TalentTeamsList/>}/>
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>

                        <Route path="notifications/*" element={<TalentMessages/>}/>

                        <Route path="dashboard" element={<TalentDashboard/>}/>
                        <Route path="job-details/:jobId" element={<JobDetailRedirect/>}/>
                        <Route path="profile" element={<ProfileEdit/>}/>
                        <Route path="contracts" element={<TalentContractsList/>}/>
                        <Route path="job-board">
                            <Route index element={<JobBoardList/>}/>
                            <Route path="job-details/:jobId" element={<JobDetailPage/>}/>
                            <Route path="*" element={<PageNotFound/>}/>
                        </Route>
                        <Route path="work-preferences" element={<WorkPreferences/>}/>


                        <Route path="projects/:status" element={<OpportunityList/>}/>

                        <Route path="*" element={<PageNotFound/>}/>

                    </Route>
                </Route>

                <Route path="dashboard" element={<Dashboard/>}/>
                <Route path="*" element={<PageNotFound/>}/>
            </>
        )
    }
}

export default Navigation;